import styled from 'styled-components';
import { UserInitialsBadge } from '@dealstack/frontend/shared/components/UserInitialsBadge/UserInitialsBadge';
import { Flex, Menu } from '@mantine/core';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { BasicUserWithPermissionRolesRes } from '@dealstack/shared/lib/generated';
import { formatUserFullName } from '@dealstack/shared/lib/format/user';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions.ts';
import { defaultToEmptyString } from '@dealstack/shared/lib/format/string.ts';
import { PermissionWrapper } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';

const UserInitialsBadgeMenu = ({ user }: { user: BasicUserWithPermissionRolesRes }) => {
	const firstName = user.firstName;
	const lastName = user.lastName;
	const name = formatUserFullName(user);

	const badge = (
		<UserInitialsBadge firstName={firstName} lastName={lastName} textVariant="sm" size="2rem" />
	);

	return (
		<Menu trigger="hover" openDelay={100} position="bottom-start">
			<Menu.Target>
				<div style={{ cursor: 'pointer' }}>{badge}</div>
			</Menu.Target>
			<Menu.Dropdown
				style={{ borderRadius: '.5rem', boxShadow: '0px 16px 32px 0px #DCDFE0' }}
			>
				<Menu.Item p="0.25rem">
					<Flex gap="0.25rem" align="center">
						{badge}
						<Text variant="p-sm" bold>
							{name}
						</Text>
					</Flex>
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
};

const NewTeamMemberCircleButton = styled(
	({ className, onClick }: { className?: string; onClick: () => void }) => {
		return (
			<Flex
				onClick={onClick}
				className={className}
				w="2rem"
				h="2rem"
				align="center"
				justify="center"
			>
				<Icon variant="add" size="lg" />
			</Flex>
		);
	}
)`
	border: 1px dashed ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 50%;
	color: ${({ theme }) => theme.v3.colors.blue[6]};
	cursor: pointer;
`;

export const DealUsers = ({
	users,
	onAddClick,
	dealId,
}: {
	users: BasicUserWithPermissionRolesRes[];
	onAddClick?: () => void;
	dealId: string;
}) => {
	return (
		<>
			{users.map((user) => {
				return <UserInitialsBadgeMenu key={user.id} user={user} />;
			})}
			<PermissionWrapper
				resourceType={ResourceType.DEAL}
				resourceId={defaultToEmptyString(dealId)}
				permissionRole={PermissionRole.VIEWER}
			>
				{onAddClick && <NewTeamMemberCircleButton onClick={onAddClick} />}
			</PermissionWrapper>
		</>
	);
};
